import { dollars, StatusData } from "@oneethos/shared"
import useLoanData from "../hooks/useLoanData"

type AmortizationProps = {
  statusData: StatusData
}

type TableRowProps = {
  label: string
  value: string | number
}

const TableRow = ({ label, value }: TableRowProps) => (
  <tr>
    <td className="p-2">{label}</td>
    <td>{value}</td>
  </tr>
)

const Amortization = ({ statusData }: AmortizationProps) => {
  const loanData = useLoanData(statusData)

  return <div>
    <table className="table">
      <thead></thead>
      <tbody>
        <TableRow label="Auto Debit" value={statusData.useAutoDebit} />
        <TableRow label="Interest Rate" value={`${loanData.rate.toFixed(2)}%`} />
        {statusData.incentiveSelected ? (
          <TableRow label="MCGB Interest Rate" value={`${loanData.mcgbProduct.incentivizedRate}%`} />
        ) : null}
        <TableRow label="Loan Date" value={loanData.amortization.loanDate?.toLocaleDateString()} />
        {statusData.incentiveSelected ? (
          <TableRow label="Monthly Payment Amount with MCGB Incentive" value={dollars(loanData.mcgb.incentiveMonthlyPayment)} />
        ) : null
        }
        <TableRow label="Monthly Payment Amount" value={dollars(loanData.amortization.payment)} />
        <TableRow label="First Statement Date" value={loanData.amortization.firstPaymentDate?.toLocaleDateString()} />
        <TableRow label="Final Payment Date" value={loanData.amortization.finalPaymentDate?.toLocaleDateString()} />
        <TableRow label="Finance Charge" value={dollars(loanData.financeCharge)} />
        <TableRow label="Sum of Total Payments" value={dollars(loanData.sumOfTotalPayments)} />
        {statusData.incentiveSelected ? (
          <TableRow label="MCGB Estimated APR" value={`${loanData.estimatedMcgbApr.toFixed(3)}%`} />
        ) : <TableRow label="Estimated APR" value={`${loanData.estimatedApr.toFixed(3)}%`} />}
      </tbody>
    </table>
  </div>
}

export default Amortization
